/** Integer display percentage; this does not decide payment eligibility. */
export function fundingAllowanceUsedPercent(limit) {
    const maximum = BigInt(limit.limitUnits);
    if (maximum <= 0n)
        return 0;
    const used = maximum - BigInt(limit.remainingUnits);
    if (used <= 0n)
        return 0;
    if (used >= maximum)
        return 100;
    return Number((used * 100n) / maximum);
}
/** Display the binding spend allowance; eligibility still checks every window. */
export function selectFundingAllowance(limits) {
    let selected = null;
    // Calendar order makes equal remaining amounts independent of provider order.
    for (const period of ['daily', 'monthly', 'yearly']) {
        const candidate = limits.find((limit) => limit.period === period);
        if (candidate &&
            (!selected || BigInt(candidate.remainingUnits) < BigInt(selected.remainingUnits)))
            selected = candidate;
    }
    return selected;
}
